import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as o } from "@mui/joy";
import { memo as t } from "react";
import a from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import r from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import m from "../../labels/CredentialsLabel/CredentialsLabel.js";
const n = t(() => /* @__PURE__ */ e.jsxs(o, { children: [
  /* @__PURE__ */ e.jsx(r, {}),
  /* @__PURE__ */ e.jsx(a, { label: "Audience name", name: "meta.audienceName", placeholder: 'e.g. "DCR Audience"' }),
  /* @__PURE__ */ e.jsx(m, {}),
  /* @__PURE__ */ e.jsx(a, { label: "Account ID", name: "meta.adAccountId", placeholder: 'e.g. "397218503624195"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Access token", name: "meta.accessToken", placeholder: 'e.g. "F57yT3QaX2nD8jHr4KlP9cVs1W6zU0E2sY8hN4bM…"', type: "masked" })
] }));
n.displayName = "MetaFormControls";
export {
  n as default
};
//# sourceMappingURL=MetaFormControls.js.map
